import React, { useState } from 'react'
import {
  ButtonContainer,
  Button,
  Card,
  FormInput,
  FormInputTextArea,
  Popup
} from 'camino-react'

import { cloudhelpPatch } from 'Utilities/CloudHelp'
import { isEmpty } from 'lodash'

const Reject = ({
  showModal,
  closeModal,
  paths
}) => {
  const [reason, setReason] = useState(null)
  const rejectProblem = () => {
    cloudhelpPatch(paths.rejectProblemPath, { status: 'rejected', reject_reason: reason })
      .then(() => { window.location.reload() })
  }
  return (
    <Popup modal open={showModal} title="Reject problem">
      <Card flat padding="xsmall">
        <FormInput label="Reject reason">
          <FormInputTextArea value={reason} onValue={value => setReason(value)} />
        </FormInput>
      </Card>
      <ButtonContainer center spaced>
        <Button color="dark" outline onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button disabled={isEmpty(reason)} onClick={() => rejectProblem()}>
          Reject
        </Button>
      </ButtonContainer>
    </Popup>
  )
}

export default Reject
